export default __webpack_public_path__ + "static/live_portrait-ca406b331d6e53ddaacc58f3a66018d1.png";